import { useEffect, useState } from 'react';
import { useCurrentUser } from './queries';

export const useShowUserPhoto = (): [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
] => {
  const { user } = useCurrentUser();
  const [showUserPhoto, setShowUserPhoto] = useState<boolean>(false);

  useEffect(() => {
    if (user?.photo) {
      setShowUserPhoto(true);
    }
  }, [user]);

  return [showUserPhoto, setShowUserPhoto];
};
